import { render } from "./charging-profile-component.vue?vue&type=template&id=71130b72"
import script from "./charging-profile-component.vue?vue&type=script&lang=js"
export * from "./charging-profile-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__